import React from "react";
import { CodeBlock } from "../ui.js";
import REFUND1 from "../../../assets/images/refund1.png";
import REFUND2 from "../../../assets/images/refund2.png";

// /document-api?i=refund-process
export default function RefundProcess() {
  return (
    <>
              <p>
                Refunds can only be performed on transactions with the status{" "}
                <b className="text-purple">mismatch.</b>
                <br />
                There are <b>two available methods</b> to process a refund: via{" "}
                <b>API</b> or via the <b>merchant web portal.</b>
              </p>
              <hr />
              <h5 className="fw-bold">1. Refund via API — refund mismatch</h5>
              <div className="mb-3">
                <a href="/document-api?i=api:refund-mismatch">
                  refund mismatch
                </a>
              </div>
              <h6 className="fw-bold">Refund Process:</h6>
              <ul>
                <li>
                  Use the <b>ref_no</b> of the transaction whose status is{" "}
                  <b className="text-purple">mismatch.</b>
                </li>
                <li>
                  Specify the refund <b>amount</b> — it must be{" "}
                  <b>equal to or less than</b> the original transaction amount.
                </li>
                <li>Submit the refund request to the API endpoint.</li>
                <li>
                  Once processed, a <b>refund callback</b> for the original
                  deposit (same <b>ref_no</b>, <b>type</b> "deposit") will be sent
                  to your deposit Callback URL with the following payload:
                </li>
              </ul>
              <CodeBlock
                className="my-3"
                text={`{
  "amount": "10.0000",
  "amount_net": "9.8716",
  "bank_account_name": "Firstname Lastname",
  "bank_account_number": "0000000000",
  "bank_code": "KBANK",
  "currency": "THB",
  "customer": {
    "name_en": "Firstname Lastname",
    "name_th": "ชื่อลูกค้า นามสกุลลูกค้า",
    "uid": "00000000-0000-0000-0000-000000000000"
  },
  "fee": "0.1200",
  "fee_rate": "1.2000",
  "fee_type": "percentage",
  "merchant": {
    "callback_url": "https://www.example.com/callback",
    "name_en": "Broker",
    "name_th": "โบรกเกอร์",
    "return_url": "",
    "uid": "00000000-0000-0000-0000-000000000000"
  },
  "mismatch": {
    "mismatch_bank_account_name_en": "Payer Name",
    "mismatch_bank_account_name_th": "ชื่อผู้โอน",
    "mismatch_bank_account_number": "1111111111",
    "mismatch_bank_code": "SCB"
  },
  "ref_no": "000000000000",
  "ref_no_bank": "000000000000",
  "status": "refund",
  "status_reason": "Transaction success.",
  "type": "deposit",
  "uid": "00000000-0000-0000-0000-000000000000",
  "vat": "0.0084",
  "vat_rate": "0.0700",
  "vat_type": "percentage"
}`}
              />

              <hr />
              <h5 className="fw-bold">2. Refund via Merchant Web Portal</h5>
              <ul>
                <li>
                  Log in to the system at: <a href="/">Signin</a>
                </li>
                <li>
                  Navigate to the <b>“Mismatch”</b> menu.
                  <br />
                  <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                    <img
                      alt="REFUND"
                      src={REFUND1}
                      className="w-100 my-3"
                      style={{ maxWidth: 700 }}
                    />
                  </div>
                </li>

                <li>
                  Locate the desired mismatch transaction and click the{" "}
                  <b>“Action”</b> button (located at the end of the row).
                </li>
                <li>
                  Select <b>“Refund”</b> — a modal window will appear showing
                  the refund details, including the destination account and the
                  refundable amount.
                </li>
                <li>
                  Enter the desired <b>Refund Amount</b>. The amount must be{" "}
                  <b>equal to or less than</b> the original transaction amount.
                  <br />
                  <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                    <img
                      alt="REFUND"
                      src={REFUND2}
                      className="w-100 my-3"
                      style={{ maxWidth: 700 }}
                    />
                  </div>
                </li>
                <li>
                  Click <b>“Refund”</b> to confirm. Once completed, the refunded
                  amount will be transferred back to the customer's account
                  according to the provided details.
                </li>
              </ul>
              <hr />
              <div className="fw-bold mb-2">📝 Important Notes:</div>
              <ul>
                <li>
                  Refunds are <b>only available for transactions with status</b>{" "}
                  <b className="text-purple">mismatch</b>
                </li>
                <li>
                  The refunded amount cannot exceed the original transaction
                  amount.
                </li>
                <li>
                  Refunds processed via API or web portal follow the same
                  internal validation and audit process.
                </li>
                <li>
                  Please ensure that your system handles refund callbacks
                  properly for transaction reconciliation.
                </li>
              </ul>
              <hr />
              <div className="fw-bold mb-2">
                Deposit Mismatch Policy (Effective from 26 October 2025)
              </div>
              <ul>
                <li>
                  Mismatch deposits{" "}
                  <b className="text-danger">above 3,500 THB</b> cannot be
                  approved automatically; they require{" "}
                  <b>manual approval by an authorized SwiftGoldPay staff member.</b>
                </li>
                <li>
                  For <b>instant deposit processing</b>, the customer's{" "}
                  <b>full name in both Thai and English</b> must be provided
                  correctly.
                </li>
              </ul>
    </>
  );
}
